import React from "react";
import { TrashIcon, RecurringIcon, ExternalCalendarIcon, EditIcon } from "./Icons";
import "./Sidebar.css";

const DAY_ABBR = ["Su", "M", "Tu", "W", "Th", "F", "Sa"];

export default function Sidebar({
  categories,
  selectedCat,
  onSelect,
  onDelete,
  onAddClick,
  onAddSubClick,
  onEditClick,
  recurrences,
  onDeleteRecurrence,
  onAddRecurrence,
  onOpenExternalCalendars,
  sidebarOpen,
}) {
  return (
    <aside className={"sidebar" + (sidebarOpen ? " open" : "")}>
      <div className="sidebar-title">
        Write<em>PushDo</em>
      </div>

      <div className="sidebar-section">Views</div>
      <button
        className={"sidebar-item" + (!selectedCat ? " active" : "")}
        onClick={() => onSelect(null)}
      >
        <span style={{ flex: 1 }}>All Tasks</span>
      </button>
      <button className="sidebar-item sidebar-ext-cal-btn" onClick={onOpenExternalCalendars}>
        <ExternalCalendarIcon />
        <span style={{ flex: 1, textAlign: "left" }}>External Calendars</span>
      </button>

      <div className="sidebar-section">Categories</div>
      {categories
        .filter((c) => !c.parent_id)
        .map((cat) => {
          const subcats = categories.filter((c) => c.parent_id === cat.id);
          return (
            <React.Fragment key={cat.id}>
              <button
                className={
                  "sidebar-item" + (selectedCat === cat.id ? " active" : "")
                }
                onClick={() => onSelect(cat.id)}
              >
                <span className="cat-dot" style={{ background: cat.color }} />
                <span style={{ flex: 1, textAlign: "left" }}>{cat.name}</span>
                <span className="cat-count">{cat.active_count || 0}</span>
                <span
                  className="cat-delete btn-icon"
                  role="button"
                  onClick={(e) => { e.stopPropagation(); onEditClick(cat); }}
                  title="Rename category"
                >
                  <EditIcon />
                </span>
                <span
                  className="cat-delete btn-icon delete"
                  role="button"
                  onClick={(e) => { e.stopPropagation(); onDelete(cat.id); }}
                  title="Delete category"
                >
                  <TrashIcon />
                </span>
              </button>
              {subcats.map((sub) => (
                <button
                  key={sub.id}
                  className={
                    "sidebar-item sidebar-subcat" +
                    (selectedCat === sub.id ? " active" : "")
                  }
                  onClick={() => onSelect(sub.id)}
                >
                  <span className="subcat-indent" />
                  <span className="cat-dot" style={{ background: sub.color }} />
                  <span style={{ flex: 1, textAlign: "left" }}>{sub.name}</span>
                  <span className="cat-count">{sub.active_count || 0}</span>
                  <span
                    className="cat-delete btn-icon"
                    role="button"
                    onClick={(e) => { e.stopPropagation(); onEditClick(sub); }}
                    title="Rename subcategory"
                  >
                    <EditIcon />
                  </span>
                  <span
                    className="cat-delete btn-icon delete"
                    role="button"
                    onClick={(e) => { e.stopPropagation(); onDelete(sub.id); }}
                    title="Delete subcategory"
                  >
                    <TrashIcon />
                  </span>
                </button>
              ))}
              <button
                className="sidebar-add-sub"
                onClick={() => onAddSubClick(cat.id)}
              >
                + Add sub-category
              </button>
            </React.Fragment>
          );
        })}

      <button className="sidebar-add" onClick={onAddClick}>
        + Add category
      </button>

      <div className="sidebar-section" style={{ marginTop: 8 }}>
        Recurring
      </div>
      {recurrences.map((rec) => (
        <div key={rec.id} className="sidebar-item sidebar-recurring">
          {rec.category_color ? (
            <span
              className="cat-dot"
              style={{ background: rec.category_color }}
            />
          ) : (
            <span className="recurring-icon">
              <RecurringIcon />
            </span>
          )}
          <span className="sidebar-recurring-info">
            <span className="sidebar-recurring-title">{rec.title}</span>
            <span className="sidebar-recurring-days">
              {rec.days_of_week.map((d) => DAY_ABBR[d]).join(" · ")}
            </span>
          </span>
          <span
            className="cat-delete btn-icon delete"
            role="button"
            onClick={() => onDeleteRecurrence(rec.id)}
            title="Delete recurring task"
          >
            <TrashIcon />
          </span>
        </div>
      ))}

      <button className="sidebar-add" onClick={onAddRecurrence}>
        + Add recurring task
      </button>

    </aside>
  );
}
